import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

export const schema: ComponentSchema = {
  type: "similar-products",
  label: "Similar Products",
  description: "A row of related products shown on the product page.",
  supportedPages: ["product"],
  variants: [{ id: "v1", label: "V1 (Grid Row)" }],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Similar Products" },
    {
      key: "productCardVariant",
      label: "Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1",
    },
    ...SECTION_STYLE_FIELDS,
  ],
};
